import React, { Component } from 'react';
import Heading from '../components/Heading';
import UserEdit from '../components/Profile/UserEdit';

export default class User extends Component {
  render() {
    return (
      <div className="user">
        <Heading text="Your Profile" />
        <UserEdit />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// src/pages/User.jsx